import React, { memo, useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';
import DOMPurify from 'dompurify';

const ALLOW_SANATIZE_TAGS_HTML = [
 'div', 'iframe', 'img', 'h1'
];

const ALLOW_SANATIZE_ATTRS_HTML = [
  'src',
  'width',
  'height',
  'style',
  'frameborder',
  'scrolling',
];

const useStyles = createUseStyles({
  htmlContainer: {
    width: '100%',
    height: '100%',
    overflow: 'auto',
    padding: '16px',
  },
  iframe: {
    width: '100%',
    height: '100%',
    border: 'none',
  },
});

const HtmlViewerViz = (props) => {
  const { t } = useTranslation();
  const { htmlData } = props;
  const classes = useStyles();

  const sanitizedHtmlContent = useMemo(() => {
    if (!htmlData) return null;
    const sanitizedHtml = DOMPurify.sanitize(htmlData, {
      ALLOWED_TAGS: ALLOW_SANATIZE_TAGS_HTML,
      ALLOWED_ATTR: ALLOW_SANATIZE_ATTRS_HTML,
    });
    return `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">
          <style>
            body {
              margin: 0;
              padding: 16px;
              font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
            }
          </style>
        </head>
        <body>
          ${sanitizedHtml}
        </body>
      </html>
    `;
  }, [htmlData]);

  if (!htmlData) {
    return <Empty description={t('No HTML content available')} />;
  }

  return (
    <div className={classes.htmlContainer}>
      <iframe
        className={classes.iframe}
        srcDoc={sanitizedHtmlContent}
        title="HTML Content Viewer"
        sandbox="allow-same-origin"
      />
    </div>
  );
};

const areEqual = (prevProps, nextProps) => {
  if (prevProps.htmlData === nextProps.htmlData) {
    return true;
  }
  return false;
};

export default memo(HtmlViewerViz, areEqual);
